var map = {
	"./de_add_to_google_wallet_add-wallet-badge.svg": 1636,
	"./en_add_to_google_wallet_add-wallet-badge.svg": 1637,
	"./fr_add_to_google_wallet_add-wallet-badge.svg": 1638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1550;